import { render } from "./TrialConfirmView.vue?vue&type=template&id=3277135a&scoped=true"
import script from "./TrialConfirmView.vue?vue&type=script&lang=js"
export * from "./TrialConfirmView.vue?vue&type=script&lang=js"

import "./TrialConfirmView.vue?vue&type=style&index=0&id=3277135a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3277135a"]])

export default __exports__